import { Component, Input } from '@angular/core';
import { ChatService } from './chat.service';

@Component({
  selector: 'bidi-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent {
  @Input() showLibrary = true;

  constructor (public chatService: ChatService) {
  }
}
